export const remita_secret = process.env.REACT_APP_REMITA_SECRET_KEY;
export const remita_public_key = process.env.REACT_APP_REMITA_PUBLIC_KEY;
export const api_token= process.env.REACT_APP_AUTH_TOKEN;
